import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Card } from 'antd'
import AliceCarousel from 'react-alice-carousel'
import { HeaderHero, SEO } from './components'
import { ROADSIDE_ASSISTANCE_BREAK_POINTS, ROADSIDE_ASSISTANCE_ARRAY } from '../constants'
import { useWindowSize } from '../utils'

import PartnerWithUsStyle from '../../styles/PartnerWithUs.module.css'

const tabletImage = 'PartnerWithUsHeaderImage_1024x300.jpeg'
const desktopImage = 'PartnerWithUsHeaderImage_1440x300.jpeg'
const largeScreenImage = 'PartnerWithUsHeaderImage_1620x300.jpeg'
const xtraLargeScreenImage = 'PartnerWithUsHeaderImage_1960x300.jpeg'
const smallImage = 'PartnerWithUsHeaderImage_375x188.jpeg'
const smallImage390 = 'PartnerWithUsHeaderImage_390x188.jpeg'
const mobileImage = 'PartnerWithUsHeaderImage_428x188.jpeg'
const mobileImage768 = 'PartnerWithUsHeaderImage_768x300.jpeg'

const { Link, Text, Title } = Typography

const PartnerWithUs = ({ }) => {
  
  return (
    <>
      <SEO
        description="Interested in becoming a CURE agent? Learn more about the CURE Agency Program and apply to be an appointed agent in Michigan, New Jersey, Pennsylvania, and Florida. "
        title="Partner With Us | CURE Auto Insurance"
        url="/PartnerWithUs"
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="PARTNER WITH US"
        xtraLargeScreenImage={xtraLargeScreenImage}
        className={`${PartnerWithUsStyle["partner-with-us-hero"]}`}
      />
         <div className={`${PartnerWithUsStyle["partner-with-us-screen"]} page-text-margin`}>
          <Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
            <section>
                <Row justify="center">
                    <Col className={`${PartnerWithUsStyle["subtitle-container"]}`}>
                        <Text className={`${PartnerWithUsStyle["subtitle"]}`}>
                            Company Overview
                        </Text>
                    </Col>
                </Row>
                <Row justify="center" style={{maxWidth: "900px", margin: "auto", textAlign: "center"}}>
                    <Col>
                        <Text className={`${PartnerWithUsStyle["body"]}`}>
                            At CURE, we believe that everyone deserves car insurance at a fair rate based primarily on their driving record. Unlike many insurers, CURE has never used education, occupation or required credit checks to determine car insurance rates.
                        </Text>
                    </Col>
                </Row>
            </section>
            <section>
                <Row justify="center">
                    <Col className={`${PartnerWithUsStyle["value-prop-container"]}`}>
                        <Row className={`${PartnerWithUsStyle["value-prop-container-inner"]}`}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img className={`${PartnerWithUsStyle["checkmark-image"]}`} src='https://assets.cure.com/img/main-site/Checkmark Image.png' alt="Checkmark" />
                                <Text className={`${PartnerWithUsStyle["body"]}`}>Competitive Commissions</Text>
                            </div>
                            <div className={`${PartnerWithUsStyle["value-prop-desktop"]}`} style={{ alignItems: "center" }}>
                                <img className={`${PartnerWithUsStyle["checkmark-image"]}`} src='https://assets.cure.com/img/main-site/Checkmark Image.png' alt="Checkmark" />
                                <Text className={`${PartnerWithUsStyle["body"]}`}>Easy Appointment Process</Text>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img className={`${PartnerWithUsStyle["checkmark-image"]}`} src='https://assets.cure.com/img/main-site/Checkmark Image.png' alt="Checkmark" />
                                <Text className={`${PartnerWithUsStyle["body"]}`}>Dedicated Agency Support Team</Text>
                            </div>
                            <div className={`${PartnerWithUsStyle["value-prop-mobile"]}`} style={{ alignItems: "center" }}>
                                <img className={`${PartnerWithUsStyle["checkmark-image"]}`} src='https://assets.cure.com/img/main-site/Checkmark Image.png' alt="Checkmark" />
                                <Text className={`${PartnerWithUsStyle["body"]}`}>Easy Appointment Process</Text>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </section>
                <section>
                        <Row justify="center">
                            <Col className={`${PartnerWithUsStyle["subtitle-container"]}`}>
                                <Text className={`${PartnerWithUsStyle["subtitle"]}`}>
                                    Select Your State
                                </Text>
                            </Col>
                        </Row>
                        <Row className={`${PartnerWithUsStyle["partner-with-us-screen-states-nav"]}`}>
                                <Col>
                                    <div>
                                        <Link className={`${PartnerWithUsStyle["mi-partners"]} ${PartnerWithUsStyle["mi-pop-up-button"]}`} href="/PartnerWithUs/MI">
                                        <img className={`${PartnerWithUsStyle["mi-pop-up-button"]}`} alt="mi-partners" />
                                        </Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div>
                                        <Link className={`${PartnerWithUsStyle["nj-partners"]}`} href="/PartnerWithUs/NJ">
                                        <img alt="nj-partners" />
                                        </Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div>
                                        <Link className={`${PartnerWithUsStyle["pa-partners"]}`} href="/PartnerWithUs/PA">
                                        <img alt="pa-partners" />
                                        </Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div>
                                        <Link className={`${PartnerWithUsStyle["fl-partners"]}`} href="/PartnerWithUs/FL">
                                        <img alt="fl-partners" />
                                        </Link>
                                    </div>
                                </Col>   
                        </Row>
                </section>
          </Col>
        </div>
    </>
  )
}

PartnerWithUs.propTypes = {}

export default PartnerWithUs